var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeywordsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 26,
    viewBox: "0 0 51 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1217"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 120",
    cx: 8.42505,
    cy: 17.7439,
    r: 7.2561,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 95",
    d: "M13.9287 12.2398L22.1848 3.98372M24.9368 1.23169L22.1848 3.98372M27.6889 9.48779L22.1848 3.98372",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.542 9.18716L37.8565 19.8726L33.295 21.9144C32.875 22.1024 32.4455 21.6712 32.6351 21.252L34.6902 16.7078L45.3764 6.02159C46.2506 5.14744 47.6678 5.14744 48.542 6.02159C49.4161 6.89574 49.4161 8.31301 48.542 9.18716Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.542 9.18716L37.8565 19.8726L33.295 21.9144C32.875 22.1024 32.4455 21.6712 32.6351 21.252L34.6902 16.7078L45.3764 6.02159C46.2506 5.14744 47.6678 5.14744 48.542 6.02159C49.4161 6.89574 49.4161 8.31301 48.542 9.18716Z",
    stroke: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordsIcon);
export default __webpack_public_path__ + "static/media/keywords-icon.b5b1bef281d5f7e099a7747b0ec1feb0.svg";
export { ForwardRef as ReactComponent };